
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import { PreRegister } from '@/wms/domain/preRegister/PreRegister';
import CustomTable from '@/core/components/shared/CustomTable.vue';
import { PreRegisterFindAll } from '@/wms/application/preRegister/search/PreRegisterFindAll';
import AddWarehousePreRegister from '@/wms/infrastructure/ui/warehousePreRegister/AddWarehousePreRegister.vue';
import { PreRegisterFindByPk } from '@/wms/application/preRegister/search/PreRegisterFindByPk';
import { PreRegisterTypeEnum } from '@/wms/domain/preRegister/PreRegisterTypeEnum';

@Component({
  name: 'ShipmentList',
  components: { CustomTable, AddWarehousePreRegister }
})
export default class ShipmentList extends Vue {
  @Inject(TYPES.PRE_REGISTER_FINDALL)
  readonly findAllPreRegister!: PreRegisterFindAll;
  @Inject(TYPES.PRE_REGISTER_FIND_BY_PK)
  readonly findByPk!: PreRegisterFindByPk;
  //Listas
  shipmentList: PreRegister[] = [];

  //Data
  isLoading = false;
  form: PreRegister = new PreRegister();
  showModal = false;

  //Ciclo de vida del componente
  async mounted() {
    await this.findAll();
  }

  //Objetos de acciones
  tableActions = {
    edit: this.edit,
    details: this.show
  };

  //Getter para obtener los campos de la tabla
  get fields() {
    return [
      {
        label: `${this.$t('general.number')}`,
        key: 'number',
        sortable: true
      },
      {
        label: `${this.$t('general.type')}`,
        key: 'type',
        sortable: true,
        formatter: (item: string) => {
          if (item.includes(PreRegisterTypeEnum.SHIPMENT)) {
            return `${this.$t('general.shipment')}`;
          }
        }
      },
      {
        label: `${this.$t('general.trackingnumber')}`,
        key: 'trackingNumber.trackingNumber',
        sortable: true
      },
      {
        label: `${this.$t('general.sender')}`,
        key: 'sender.fullName',
        sortable: true
      },
      {
        label: `${this.$t('general.recipient')}`,
        key: 'recipient.fullName',
        sortable: true
      },
      {
        label: `${this.$t('general.status')}`,
        key: 'state',
        formatter: (item: any) => this.$t(`general.${item}`),
        sortable: true
      },
      {
        label: `${this.$t('general.actions')}`,
        key: 'actions'
      }
    ];
  }

  //Funcion invocada para ejecutar la edicion
  edit(input: PreRegister) {
    this.$router.push({ path: 'shipment', query: { type: input.type, number: input.number } });
  }

  //Funcion invocada para obtener una lista de todos los pre registros que se han realizado
  async findAll() {
    try {
      this.isLoading = true;
      const res = await this.findAllPreRegister.execute(PreRegisterTypeEnum.SHIPMENT);
      this.shipmentList = res.length > 0 ? res.reverse() : [];
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  }

  //Funcion invocada para obtener un pre registro concreto
  async show(input: PreRegister) {
    try {
      this.isLoading = true;
      const res = await this.findByPk.execute({
        type: input.type,
        number: input.number
      });
      this.form = res;
      this.isLoading = false;
      this.showModal = true;
    } catch (error) {
      this.isLoading = false;
    }
  }
}
